function invoke() {
  window.location.reload();
}

export default {
  invoke,
};
